
import React, { useState } from 'react';
import { Input, Avatar, List } from 'antd';
import { formatDisplayValue } from '../../utils/formatDisplayValue';
// import 'antd/dist/antd.css';

const ChatBox = ({messages}) => {
    const screenHeight = document.body.clientHeight-56;
    console.log('screenHeight - ', screenHeight)
    console.log('messages - ', messages)
    // const [messages, setMessages] = useState([
    //     { id: 1, text: '你好呀！', isSelf: false },
    //     { id: 2, text: '哈喽！有什么事吗？', isSelf: true }
    // ]);
    // const [inputValue, setInputValue] = useState('');

    // const handleInputChange = (e) => {
    //     setInputValue(e.target.value);
    // };

    // const handleSendMessage = () => {
    //     if (inputValue.trim() === '') return;
    //     const newMessage = {
    //         id: messages.length + 1,
    //         text: inputValue,
    //         isSelf: true
    //     };
    //     setMessages([...messages, newMessage]);
    //     setInputValue('');
    // };

    return (
        <div style={{ width: '400px', border: '1px solid #ccc', borderRadius: '4px', padding: '16px', margin: '0 auto',maxHeight:screenHeight,overflowY:"auto" }}>
            <List
                dataSource={messages}
                renderItem={(item) => (
                    <div style={{ display: 'flex', justifyContent: item.role=='user' ? 'flex-end' : 'flex-start', marginBottom: '8px' }}>
                        {item.role!='user' && <Avatar src="favicon.png" shape="square" style={{ marginRight: '8px', width: 30, height: 30 }} />}
                        {/* {item.role!='user' && <Avatar src={[require("../../img/logo.png")]} style={{ marginRight: '8px' }} />} */}
                        {/* <div style={{ backgroundColor: item.role=='user' ? '#e6f7ff' : '#f5f5f5', padding: '8px', borderRadius: '4px', width:"60%" }}> */}
                        <div style={{ backgroundColor: item.role=='user' ? 'rgb(137,217,97)' : '#f5f5f5', padding: '8px', borderRadius: '4px', width:"60%", whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                            {formatDisplayValue(item && item.message !== undefined ? item.message : item)}
                        </div>
                        {item.role=='user' && <Avatar src="avatar_cand.png" shape="square" style={{ marginLeft: '8px', width: 30, height: 30 }} />}
                        {/* {item.role=='user' && <Avatar icon={<UserOutlined />} shape="square" style={{ marginLeft: '8px', width: 30, height: 30 }} />} */}
                    </div>
                )}
            />
            {/* <div style={{ display: 'flex', marginTop: '16px' }}>
                <Input
                    value={inputValue}
                    onChange={handleInputChange}
                    placeholder="输入消息"
                    style={{ flex: 1, marginRight: '8px' }}
                />
                <Button onClick={handleSendMessage}>发送</Button>
            </div> */}
        </div>
    );
};

export default ChatBox;
    